module.exports = __webpack_public_path__ + "img/nav-done.2f60a2c3.svg";